import i18next from 'i18next';

import {escapeHtml} from './html';

const t = (key, defaultValue, options = {}) => (
    i18next.t ? i18next.t(key, {defaultValue, ...options}) : defaultValue
);

export const normalizeSelectValue = (value) => (value === null || value === undefined ? '' : String(value));

export const sameId = (left, right) => normalizeSelectValue(left) === normalizeSelectValue(right);

export const normalizeCollection = (payload) => {
    if (Array.isArray(payload)) {
        return payload;
    }
    if (!payload || typeof payload !== 'object') {
        return [];
    }
    for (const key of ['data', 'results', 'items', 'categories']) {
        if (Array.isArray(payload[key])) {
            return payload[key];
        }
    }
    return [];
};

export const flattenCategoryTree = (items, depth = 0) => {
    const categories = [];
    (items || []).forEach((item) => {
        if (!item || typeof item !== 'object') {
            return;
        }
        const id = item.id || item.category_id || item.value || item.code;
        const label = item.name || item.label || item.title || item.display_name || id;
        if (id) {
            categories.push({
                id: String(id),
                label: `${depth ? `${'— '.repeat(depth)}` : ''}${label}`,
                raw: item,
            });
        }
        const children = item.children || item.subcategories || item.categories || [];
        if (Array.isArray(children) && children.length) {
            categories.push(...flattenCategoryTree(children, depth + 1));
        }
    });
    return categories;
};

export const renderDraftSearchableSelect = ({
    id,
    label,
    options,
    selectedValue,
    placeholder = t('ads:draftEditor.selectOption', 'Select option'),
    searchPlaceholder = t('ads:draftEditor.searchOptions', 'Search'),
    dataAttributes = '',
    disabled = false,
}) => {
    const normalizedValue = normalizeSelectValue(selectedValue);
    const selectedOption = (options || []).find((option) => sameId(option.value, normalizedValue));
    const selectedLabel = selectedOption ? selectedOption.label : placeholder;
    const isPlaceholder = !selectedOption;
    const optionItems = (options || []).map((option, index) => {
        const selected = sameId(option.value, normalizedValue);
        return `
            <li
                id="${id}-dropdown-option-${index + 1}"
                class="integrations-select__option draft-custom-select-option ${selected ? 'is-selected' : ''}"
                role="option"
                aria-selected="${selected ? 'true' : 'false'}"
                data-select-value="${escapeHtml(option.value)}"
                data-select-label="${escapeHtml(option.label)}"
            >
                ${escapeHtml(option.label)}
            </li>
        `;
    }).join('');

    return `
        <label for="${id}" class="draft-field-label">${escapeHtml(label)}</label>
        <div class="integrations-select draft-custom-select ${disabled ? 'is-disabled' : ''}" data-draft-custom-select ${dataAttributes}>
            <button
                type="button"
                id="${id}"
                class="integrations-select__toggle draft-custom-select-toggle"
                aria-haspopup="listbox"
                aria-expanded="false"
                aria-controls="${id}-dropdown"
                ${disabled ? 'disabled' : ''}
            >
                <span class="integrations-select__label draft-custom-select-label ${isPlaceholder ? 'integrations-select__label--placeholder' : ''}">
                    ${escapeHtml(selectedLabel)}
                </span>
                <span class="integrations-select__arrow" aria-hidden="true"></span>
            </button>
            <div class="integrations-select__dropdown draft-custom-select-dropdown" role="presentation">
                <div class="draft-custom-select-search-wrap">
                    <input
                        type="text"
                        class="draft-custom-select-search"
                        placeholder="${escapeHtml(searchPlaceholder)}"
                        autocomplete="off"
                    >
                </div>
                <ul class="integrations-select__options" role="listbox" id="${id}-dropdown">
                    <li
                        id="${id}-dropdown-option-0"
                        class="integrations-select__option integrations-select__option--placeholder draft-custom-select-option ${isPlaceholder ? 'is-selected' : ''}"
                        role="option"
                        aria-selected="${isPlaceholder ? 'true' : 'false'}"
                        data-select-value=""
                        data-select-label="${escapeHtml(placeholder)}"
                    >
                        ${escapeHtml(placeholder)}
                    </li>
                    ${optionItems}
                </ul>
            </div>
        </div>
    `;
};
